import { ReactNode } from 'react';
import { Helmet } from 'react-helmet-async';
import { titlePrefix } from '@/utils/titlePrefix';

export const PageTitle = ({ children }: { children: ReactNode }) => (
  <Helmet defaultTitle={`${titlePrefix}Hudl Statsbomb`} titleTemplate={`${titlePrefix}%s | Hudl Statsbomb`}>
    <title>{children}</title>
  </Helmet>
);
